import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import fr from 'vuetify/es5/locale/fr'
import es from 'vuetify/es5/locale/es'
import de from 'vuetify/es5/locale/de'

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    locales: { fr, es, de },
    current: 'fr'
  },
})
